import { Box, Checkbox, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import { ScreenshotAccordion } from "../../../../components/ScreenshotAccordion";
import GuidelineStep from "../components/GuidelineStep";
import microsoft_azure13 from "./images/microsoft_azure13.png";
import microsoft_azure14 from "./images/microsoft_azure14.png";
import microsoft_azure15 from "./images/microsoft_azure15.png";
import microsoft_azure16 from "./images/microsoft_azure16.png";
import microsoft_azure17 from "./images/microsoft_azure17.png";
import microsoft_azure18 from "./images/microsoft_azure18.png";
import microsoft_azure19 from "./images/microsoft_azure19.png";

const MicrosoftAzureApplicationRoles = ({
  addToExpandedList,
  integrationName,
}) => {
  const entraIdRoles = ["Security Reader", "Global Reader"];
  const colors = useColors();
  return (
    <GuidelineStep title="Add Application Roles">
      <Typography variant="body1">
        You can skip this part if you have already assigned the required roles
        in the{" "}
        <b>
          {integrationName === "microsoft_office_365"
            ? "Microsoft Entra ID "
            : "Microsoft 365 "}
        </b>
        integration.
      </Typography>
      <Typography variant="body1">
        From the top search bar, search for <strong>Roles</strong> and click on{" "}
        <strong>Microsoft Entra roles and administrators</strong>
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure13,
            altext: "Search for Roles",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        For the Following roles do the following steps:
      </Typography>
      <Box
        sx={{
          width: "700px",
          backgroundColor: colors.grey_200,
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="subtitle2"
          color={colors.primary_darker}
          gutterBottom
        >
          The list of required roles
        </Typography>
        <Typography variant="body2" gutterBottom>
          Check the box for each completed role to track the progress
        </Typography>
        {entraIdRoles?.map((role, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <Checkbox />
            <Typography>{role}</Typography>
          </Box>
        ))}
      </Box>
      <Typography variant="body1">
        Search for the required role and select it
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure14,
            altext: "Find the required role",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Click on <strong>Add assignments</strong>
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure15,
            altext: "Add role assignment",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Click on <strong>Select Members</strong>
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure16,
            altext: "Add role assignment",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Search for the integration you have created for Breeze and select it.
        Then click <strong>Select</strong>
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure17,
            altext: "Add role assignment to the application",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Click <strong>Next</strong>
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure18,
            altext: "Add role assignment to the application",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Leave the default settings, enter some justification, and click{" "}
        <strong>Assign</strong>
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure19,
            altext: "Approve the role assignment",
          },
        ]}
        onExpanded={addToExpandedList}
      />
    </GuidelineStep>
  );
};

export default MicrosoftAzureApplicationRoles;
